import {Component, Vue} from 'vue-property-decorator';
import {getBranches} from "../../utils/miscellanea";

const template = `
  <div class="pp pp--breq">
    <div class="pp__close menu__sndw  menu__sndw--active" @click="$emit('close')"></div>
    
    <div class="pp__content">
      <div class="bmod">
        <div class="bmod__pick">
          <div class="bmod__pick-left">
            <div class="bmod__title2 bmod__title2--br">выбрать представителя:</div>
            <div class="bmod__branch" v-for="branch in branches" :class="{'bmod__branch--active': branch.active}">
              <a class="bmod__branch-title" :href="branch.link">{{ branch.title }}</a>
            </div>
<!--            <div class="bmod__btn bmod__btn-left">петейти →</div>-->
          </div>
          <div class="bmod__pick-right">
            <div class="bmod__title2" v-if="isMainPage">Вы здесь</div>
            <div class="bmod__title2" v-if="!isMainPage">Перейти:</div>
            <div class="bmod__branch bmod__branch--home" v-if="!isMainPage">
              <a class="bmod__branch-title" href="/ru/franchise">
                <i class="img-earth"></i>
                Сайт DAKO Professional Team
              </a>
            </div>
            <div class="bmod__branch bmod__branch--home" v-if="isMainPage">
              <a class="bmod__branch-title">
                <i class="img-earth"></i>
                Сайт DAKO Professional Team
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
`;


@Component({
  template: template,
})
export default class BranchChoseModal extends Vue {
  branches: any[] = [];

  created() {
    const link = location.pathname;

    this.branches = getBranches().map((b: any) => {
      b.active = b.link == link;
      return b;
    });
  }

  get isMainPage() {
    return this.branches.findIndex((b: any) => b.active) == -1;
  }
}
